export default __webpack_public_path__ + "static/media/TipsCard.e1369ef6.svg";